import {selectAll, selectDoc} from "../utils/utils";
import Swiper from 'swiper/bundle';

export class CustomReviews {
    constructor(el) {
        if (el) {
            this.init(el);
        }
    }

    init(el) {
        this.el = el;
        this.reviewsSwiper = {};
        this.pressSwiper = {};
        this.props();
        this.render();
    }

    props() {
        this.customReviewsContainer = selectAll("[data-custom-reviews]");
        this.customPressContainer = selectAll("[data-custom-press]");
        this.customReviewsToggleButtons = selectAll('.custom-reviews__toggle button');
    }

    render() {
        this.customReviewsCarousel();
        this.customPressCarousel();
        this.customReviewsToggle();
    }

    customReviewsCarousel = () => {
        for (var i = 0; i < this.customReviewsContainer.length; i++) {
            this.reviewsSwiper = new Swiper(this.customReviewsContainer[i], {
                slidesPerView: 1,
                spaceBetween: 0,
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    990: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: ".custom-reviews__navigation__reviews .swiper-button-next",
                            prevEl: ".custom-reviews__navigation__reviews .swiper-button-prev",
                        },
                    }
                }
            });
        }
    };

    customPressCarousel = () => {
        for (var i = 0; i < this.customPressContainer.length; i++) {
            this.pressSwiper = new Swiper(this.customPressContainer[i], {
                slidesPerView: 1,
                spaceBetween: 0,
                scrollbar: {
                    el: '.swiper-scrollbar.press',
                    draggable: true,
                },
                breakpoints: {
                    990: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                        navigation: {
                            nextEl: ".custom-reviews__navigation__press .swiper-button-next",
                            prevEl: ".custom-reviews__navigation__press .swiper-button-prev",
                        },
                    }
                }
            });
        }
    };

    customReviewsToggle = () => {
        for (var i = 0; i < this.customReviewsToggleButtons.length; i++) {
            this.customReviewsToggleButtons[i].addEventListener('click', this.toggleButtonsHandler.bind(this));
        }
    }

    toggleButtonsHandler = (target) => {
        if (!target.currentTarget.classList.contains('active')) {
            this.customReviewsToggleButtons[0].classList.toggle('active');
            this.customReviewsToggleButtons[1].classList.toggle('active');
            selectDoc('[' + this.customReviewsToggleButtons[0].dataset.target + ']').classList.toggle('hidden');
            selectDoc('[' + this.customReviewsToggleButtons[1].dataset.target + ']').classList.toggle('hidden');
            selectDoc('.custom-reviews__navigation__reviews').classList.toggle('hidden')
            selectDoc('.custom-reviews__navigation__press').classList.toggle('hidden')
            this.reviewsSwiper.update();
            this.pressSwiper.update();
        }
    }
}
